import { Component } from '@angular/core';
import { GiftBagService } from './gift-bag.service';
import { GiftBagModalComponent } from 'src/app/features/modals/gift-bag-modal/gift-bag-modal.component';
import { ModalService } from '../modal/modal.service';

@Component({
  selector: 'app-gift-bag',
  templateUrl: './gift-bag.component.html',
  styleUrls: ['./gift-bag.component.scss']
})
export class GiftBagComponent {

  constructor(
    private modalService: ModalService,
    private giftBagService: GiftBagService
  ) { }

  public showGiftBag() {
    this.modalService.showModal(GiftBagModalComponent);
  }

}
